import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyBlockUnblockValidationSchema } from "../schemas/blockUnblockCompany.schema";

interface UseEnableClientCompanyProps {
  companyId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useEnableClientCompany = ({ companyId, onSuccess, onError }: UseEnableClientCompanyProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<void, AxiosError, CompanyBlockUnblockValidationSchema>({
    mutationKey: ['enableCompany', companyId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/companies/${companyId}/enable`, {
        company: data,
      });
    },
    onSuccess,
    onError,
  });
};

export default useEnableClientCompany;
